export const APPROVAL_ANSWER_STRINGS = {
  approve: 'Approve',
  reject: 'Reject',
  counteroffer: 'Counteroffer',
  reason: 'Reason',
  describeReason: 'Details',
  newFee: (currency?: string | null) => (currency ? `Your price (${currency})` : 'Your price'),
  feeHint: 'Applies to all formats',
  comment: 'Comment (optional)',
  addComment: 'Add comment',
  min0: 'Must be 0 or more',
  sameFee: (offered: string) => `Must differ from ${offered}`,
  rejectReasons: {
    not_owned: 'Not My Publishing',
    reputation_risk: 'Reputation Concerns',
    licensing_restrictions: 'Licensing Restrictions',
    artistic_integrity: 'Artistic Integrity',
    other: 'Other',
  },
} as const
